    document.addEventListener("DOMContentLoaded", function () {
        const observer=new MutationObserver(()=> {
                const form=document.querySelector(".sc-pl-product-selector-form__form");
                const comboBox=form?.querySelector('[role="combobox"]');
                const selectorWrappers=form?.querySelectorAll(".sc-pl-product-selector-form__selector-wrapper");

                if (form && comboBox && selectorWrappers.length >=2) {
                    const radiusSelector=selectorWrappers[selectorWrappers.length - 1];

                    if (comboBox && radiusSelector) {
                        const heading=document.createElement("h4");
                        heading.textContent="Find Your Store";
                        radiusSelector.parentNode.insertBefore(heading, radiusSelector);
                        radiusSelector.parentNode.insertBefore(comboBox.closest(".sc-container"), radiusSelector);
                        observer.disconnect();
                    }
                }
            });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
});
